import React, { useState } from 'react'
import './styles.css'
import Hotkeys from 'react-hot-keys'

const NEXT_KEY = 'control+n'
const BACK_KEY = 'control+b'

const getNavStyles = (index, length) => {
  let styles = []
  for (let i = 0; i < length; i++) {
    if (i < index) {
      styles.push('done')
    } else if (i === index) {
      styles.push('doing')
    } else {
      styles.push('todo')
    }
  }
  return styles
}

const getButtonsState = (index, length) => {
  if (index > 0 && index < length - 1) {
    return {
      showPreviousBtn: true,
      showNextBtn: true,
    }
  } else if (index === 0) {
    return {
      showPreviousBtn: false,
      showNextBtn: true,
    }
  } else {
    return {
      showPreviousBtn: true,
      showNextBtn: false,
    }
  }
}

export const MultiStepForm = ({
  steps,
  showNavigation,
  onNext,
  onBeforeNext,
  onPrevious,
  onGoBack,
  onFinish,
  isValid,
  isDocumentStepValid,
  isBusy = false,
}) => {
  const [, setStyles] = useState(getNavStyles(0, steps.length))
  const [componentState, setComponent] = useState(0)
  const [, setButtons] = useState(getButtonsState(0, steps.length))

  const setStepState = (index) => {
    setStyles(getNavStyles(index, steps.length))
    setComponent(index < steps.length ? index : componentState)
    setButtons(getButtonsState(index, steps.length))
  }

  const next = async () => {
    if (isBusy) return
    const { name } = steps[componentState]
    const result = onBeforeNext(name)
    if (result) {
      if (!isLastStep()) {
        // Wait for save to complete before advancing to the next step
        await onNext(name)
        setStepState(componentState + 1)
      } else {
        await onFinish(name)
      }
    }
  }

  const previous = () => {
    if (componentState > 0) {
      setStepState(componentState - 1)
      onPrevious()
    } else {
      onGoBack()
    }
  }

  const onKeyUp = (keyName, e, handle) => {
    if (keyName === NEXT_KEY && isValid) {
      if (isBusy) {
        return
      }
      if (isSecondStep() && !isDocumentStepValid) {
        return
      }
      next()
    }

    if (keyName === BACK_KEY) {
      if (isBusy) {
        return
      }
      previous()
    }
  }
  const onKeyDown = (keyName, e, handle) => {}

  const isLastStep = () => componentState + 1 === steps.length

  const isSecondStep = () => componentState === 1

  return (
    <Hotkeys keyName={[NEXT_KEY, BACK_KEY].join(',')} onKeyDown={onKeyDown} onKeyUp={onKeyUp}>
      <div className={'multi-step-form'}>
        {steps[componentState].component}
        <div style={showNavigation ? {} : { display: 'none' }} className={'multi-step-form-navigation'}>
          <button className='btn btn-info btn btn-info-default' onClick={previous} disabled={isBusy}>
            <i className='fa fa-arrow-left' /> Back (^B)
          </button>

          <button
            className='btn btn-info btn btn-info-default'
            onClick={next}
            disabled={isBusy || (isSecondStep() ? !isDocumentStepValid : !isValid)}
          >
            {isLastStep() ? 'Finish' : 'Save & Next'} (^N) <i className='fa fa-arrow-right' />
          </button>
        </div>
      </div>
    </Hotkeys>
  )
}
